import { render, staticRenderFns } from "./withdrawSetDialogOld.vue?vue&type=template&id=a9894010&"
import script from "./withdrawSetDialogOld.vue?vue&type=script&lang=js&"
export * from "./withdrawSetDialogOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports